<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6">
        <LsSupportHeader label="Pause or discontinue my subscription" />
      </div>
    </div>
    <BLoading :active.sync="properties.loadingStatus.isLoading" />
    <div v-if="!properties.loadingStatus.isLoading" class="columns">
      <div class="column is-6">
        <div class="pause-subscription-view--content">
          <p class="pause-subscription-view--p">
            Thanks for spending the season with us! When the grass starts growing next spring, we'll
            send you an email letting you know when we've got you scheduled.
          </p>
          <LsButton
            v-if="activeProperties.length"
            bg-color="primary"
            text="PAUSE SERVICE UNTIL SPRING"
            test-id="pause"
            track-id="pause_subscription_view-pause"
            class="pause-subscription-view--pause"
            @click="pauseSubscription"
          />
        </div>

        <p v-if="shouldCancel" class="pause-subscription-view--cancel-link">
          Looking to discontinue service entirely?
          <a test-id="cancel" @click="cancelSubscription">Click here</a>
        </p>

        <LsInfoCard v-if="!activeProperties.length">
          <p>You currently don't have any active subscriptions.</p>
        </LsInfoCard>
      </div>
    </div>
  </div>
</template>

<script>
import { LsButton, LsInfoCard } from '@/components/common';
import { lsModalService } from 'ls-vue-common';
import { ChangeFrequencyModal, PauseSubscriptionModal, CancelSubscriptionModal } from '@/modals';
import { mapGetters, mapActions, mapState } from 'vuex';
import {
  PROPERTIES__PROPERTIES_IN_ARRAY,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
  PROPERTIES__CAN_CANCEL_MOWING_SERVICES,
} from '@/store/types';
import _ from 'lodash';
import PauseCancelSuccessModal from '@/modals/PauseCancelSuccess/PauseCancelSuccessModal.vue';
import { LsSupportHeader } from '../components';

export default {
  name: 'PauseSubscriptionView',
  components: {
    LsSupportHeader,
    LsButton,
    LsInfoCard,
  },
  data() {
    return {
      activeProperties: [],
    };
  },
  computed: {
    ...mapState(['properties']),
    ...mapGetters([PROPERTIES__PROPERTIES_IN_ARRAY, PROPERTIES__CAN_CANCEL_MOWING_SERVICES]),
    generatePropertyOptions() {
      return _.map(this[PROPERTIES__PROPERTIES_IN_ARRAY], (property) => {
        return {
          label: _.get(property, 'street', ''),
          value: _.get(property, 'property_id', 0),
          disabled: _.isNil(property.active_mowing_schedule_id),
          active_mowing_schedule_id: _.get(property, 'active_mowing_schedule_id', null),
          priced: _.get(property, 'priced', {}),
        };
      });
    },
    shouldCancel() {
      return this.activeProperties.length && (this.$route.params.serviceId || null);
    },
  },
  async created() {
    await this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();

    this.activeProperties = _.reduce(
      this[PROPERTIES__PROPERTIES_IN_ARRAY],
      (result, property) => {
        if (!_.isNil(property.active_mowing_schedule_id)) {
          result.push(property.property_id);
        }

        return result;
      },
      []
    );
  },
  methods: {
    ...mapActions([PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]),
    pauseSubscription() {
      lsModalService.open({
        parent: this,
        component: PauseSubscriptionModal,
        events: {
          'open-success': (data) => {
            lsModalService.open({
              parent: this,
              component: PauseCancelSuccessModal,
              props: { data },
            });
          },
          'change-frequency': () => {
            lsModalService.open({
              parent: this,
              component: ChangeFrequencyModal,
            });
          },
        },
        props: {
          activeProperties: this.activeProperties,
          propertyOptions: this.generatePropertyOptions,
        },
        width: 650,
      });
    },
    cancelSubscription() {
      const { property_id } = this.$route.params;

      if (
        property_id &&
        !(this.properties.propertiesById[property_id] || {}).can_cancel_mowing_services
      ) {
        return this.$router.push({
          name: 'blockCancelSubscription',
        });
      }

      if (!this[PROPERTIES__CAN_CANCEL_MOWING_SERVICES]) {
        return this.$router.push({
          name: 'blockCancelSubscription',
        });
      }

      lsModalService.open({
        parent: this,
        component: CancelSubscriptionModal,
        props: {
          isLtrs: this.$route.params.isLtrs || false,
          serviceId: this.$route.params.serviceId || null,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pause-subscription-view--content {
  border-bottom: 1px solid $primary-light;
  margin-bottom: 18px;
}

.pause-subscription-view--pause {
  margin-bottom: 30px;
}

.pause-subscription-view--p {
  margin-bottom: 20px;
}

.pause-subscription-view--cancel-link {
  font-weight: bold;
}
.themed-app {
  .pause-subscription-view--content {
    border-color: $theme-color-primary-light;
  }
}
</style>
